import { render, staticRenderFns } from "./PerfilCliente.vue?vue&type=template&id=c8a3b132"
import script from "./PerfilCliente.vue?vue&type=script&lang=js"
export * from "./PerfilCliente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports